<template>
  <v-card>
    <span class="float-right">
      <v-btn
        depressed
        @click="
          !editSenderDialog
            ? (editSenderDialog = true)
            : (editSenderDialog = false)
        "
        dense
        v-if="txn_status === 'Paid' || txn_status === 'Post' ? false : true"
        text
        class="me-2"
        color="primary"
        ><v-icon class="me-2">mdi-square-edit-outline </v-icon>Edit
      </v-btn>
    </span>
    <!-- {{ senderInfo }} -->
    <v-form>
      <table style="width: 100%">
        <tr>
          <td>Sender Name</td>
          <td>
            <span class="font-weight-bold">{{
              senderInfo.middle_name
                ? senderInfo.first_name +
                  " " +
                  senderInfo.middle_name +
                  " " +
                  senderInfo.last_name
                : senderInfo.last_name
                ? senderInfo.first_name + " " + senderInfo.last_name
                : senderInfo.first_name
            }}</span>
          </td>
          <td>Customer ID</td>
          <td>
            <span class="font-weight-bold">
              {{ senderInfo.customer_id ? senderInfo.customer_id : null }}</span
            >
          </td>
        </tr>
        <tr>
          <td>User ID</td>
          <td class="font-weight-bold">
            {{ senderInfo.user_id ? senderInfo.user_id : null }}
          </td>
          <td>Address</td>
          <td class="font-weight-bold">
            <span>
              {{ senderInfo.address ? senderInfo.address : null }}
            </span>
          </td>
        </tr>
        <tr>
          <td>User Type</td>
          <td class="font-weight-bold">
            <span>
              {{ senderInfo.user_type ? senderInfo.user_type : null }}
            </span>
          </td>

          <td>Kyc</td>
          <td>
            <span class="font-weight-bold">{{
              senderInfo.kyc ? senderInfo.kyc : null
            }}</span>
          </td>
        </tr>
        <tr>
          <td>ID type</td>
          <td>
            <span class="font-weight-bold">{{
              this.senderInfo.id_type ? senderInfo.id_type.value : null
            }}</span>
          </td>
          <td>ID Number</td>
          <td class="font-weight-bold">
            <span>
              {{ senderInfo.id_number ? senderInfo.id_number : null }}
            </span>
          </td>
        </tr>
        <tr>
          <td>Issue Date</td>
          <td class="font-weight-bold">
            <span>
              {{ senderInfo.issue_date ? senderInfo.issue_date : null }}
            </span>
          </td>
          <td>Expiry Date</td>
          <td class="font-weight-bold">
            <span>
              {{ senderInfo.expire_date ? senderInfo.expire_date : null }}
            </span>
          </td>
        </tr>
        <tr>
          <td>Issue Country</td>
          <td class="font-weight-bold">
            <span>
              {{ senderInfo.issue_country ? senderInfo.issue_country : null }}
            </span>
          </td>
          <td>Email Id</td>
          <td class="font-weight-bold">
            <span>
              {{ senderInfo.email ? senderInfo.email : null }}
            </span>
          </td>
        </tr>
        <tr>
          <td>Mobile Number</td>
          <td class="font-weight-bold">
            <span class="font-weight-bold">{{
              senderInfo.mobile ? senderInfo.mobile : null
            }}</span>
          </td>
          <td>DOB</td>
          <td class="font-weight-bold">
            <span>
              {{ senderInfo.dob ? senderInfo.dob : null }}
            </span>
          </td>
        </tr>
        <tr>
          <td>Gender</td>
          <td class="font-weight-bold">
            <span>
              {{
                senderInfo.gender
                  ? senderInfo.gender === "Male"
                    ? "Male"
                    : "Female"
                  : null
              }}
            </span>
          </td>
          <td>Nationality</td>
          <td class="font-weight-bold">
            <span>
              {{
                senderInfo.nationality && senderInfo.nationality.nationality
                  ? senderInfo.nationality.nationality
                  : null
              }}
            </span>
          </td>
        </tr>
        <tr>
          <td>occupation</td>
          <td class="font-weight-bold">
            <span>
              {{ senderInfo.occupation ? senderInfo.occupation.value : null }}
            </span>
          </td>
          <td>employer</td>
          <td class="font-weight-bold">
            <span>
              {{ senderInfo.employer ? senderInfo.employer : null }}
            </span>
          </td>
        </tr>
        <tr>
          <!-- <td>Purpose of remittance</td>
          <td>
            <span>
              {{
                senderInfo.purpose_of_remittance
                  ? senderInfo.purpose_of_remittance.value
                  : null
              }}
            </span>
          </td> -->
          <td>Source of funds</td>
          <td class="font-weight-bold">
            <span>
              {{
                senderInfo.source_of_funds
                  ? senderInfo.source_of_funds.value
                  : null
              }}
            </span>
          </td>
        </tr>
      </table></v-form
    >
    <div class="text-center">
      <v-dialog persistent v-model="editSenderDialog" width="900px">
        <SenderInfoEditVue
          @closeDialog="closeDialog"
          :senderInfo="senderInfo"
          @DataUpdated="DataUpdated"
        />
      </v-dialog>
    </div>
  </v-card>
</template>

<script>
import SenderInfoEditVue from "./EditTxnDetails/SenderInfoEdit.vue";
export default {
  data() {
    return {
      editSenderDialog: false,
    };
  },
  components: {
    SenderInfoEditVue,
  },
  props: {
    senderInfo: {
      type: Object,
    },
    txn_status: {
      type: String,
    },
  },
  methods: {
    closeDialog() {
      this.editSenderDialog = false;
    },
    DataUpdated() {
      this.$emit("senderdataUpdated");
    },
  },
};
</script>

<style lang="scss" scoped>
th,
td {
  border-bottom: 1px solid rgb(231, 229, 229);
  border-collapse: collapse;
  padding: 5px;
}
</style>
